var React = require('react');

function LightSwitch (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M96,272V240H288v32Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M320,0H64A64,64,0,0,0,0,64V448a64,64,0,0,0,64,64H320a64,64,0,0,0,64-64V64A64,64,0,0,0,320,0ZM192,32a16,16,0,1,1-16,16A16,16,0,0,1,192,32Zm0,448a16,16,0,1,1,16-16A16,16,0,0,1,192,480Zm96-224V368a48,48,0,0,1-48,48H144a48,48,0,0,1-48-48V144a48,48,0,0,1,48-48h96a48,48,0,0,1,48,48Z","className":"fa-primary","key":2})]);
}

LightSwitch.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = LightSwitch;

LightSwitch.default = LightSwitch;
